import {
  SurveyAttachedFile,
  SurveyAnswer as BaseSurveyAnswer,
  SurveyAnswerType,
} from "@graffer-inc/cloud-gov-core";
import { FormData as GrafferFormData } from "@graffer-inc/form-schema";

export class SurveyAnswer extends BaseSurveyAnswer {
  id: string;

  answer: GrafferFormData;

  files: SurveyAttachedFile[];

  constructor(values: SurveyAnswerType) {
    super(values);
    this.id = values.id;
    this.answer = values.answer;
    this.files = values.files;
  }

  static fromJSON(values: SurveyAnswerType) {
    return new SurveyAnswer(values);
  }

  static fromJSONArray(json?: SurveyAnswerType[]) {
    if (!json) {
      return [];
    }
    return json.map(SurveyAnswer.fromJSON);
  }
}
